import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { ChangeCardStatusMutationArgs } from '../components/Cards/Cards.types';

export const useChangeCardStatusQuery = () => {
  const { mutateAsync, isLoading } = useMutation((args: ChangeCardStatusMutationArgs) =>
    api.put(API_URL.CARDS_BY_CARD_ID(args.id), {
      status: args.status,
      locked_purse_ids: args.lockedPursesIds,
    })
  );
  return {
    mutateAsync,
    isLoading,
  };
};
